import { render } from "./SectionBorder.vue?vue&type=template&id=0f2eeb1a"
const script = {}

import exportComponent from "/home/forge/orders.cash-mere.ch/releases/80909800/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__